import ReactPlayer from 'react-player';

export const addLoomPlayer = () => {
  ReactPlayer.addCustomPlayer?.({
    key: 'loom',
    name: 'Loom',
    canPlay: (url) => url.includes('loom.com'),
    // react-player types expect full video props; custom Loom renderer only uses src.
    player: ((props: { src: string }) => {
      const src = props.src.replaceAll('share/', 'embed/');
      return (
        <div className="w-full relative aspect-video">
          <iframe
            id="loom-player"
            src={src}
            style={{
              position: 'absolute',
              top: '0',
              left: '0',
              width: '100%',
              height: '100%',
            }}
            allowFullScreen
          />
        </div>
      );
    }) as any,
  });
};
